function DashboardCardStyle(theme, ownerState) {
    const { palette, typography, boxShadows, functions, transitions, breakpoints, borders } = theme;
    const { sidebarState, miniSidenav, hiddenSidenav, deviceStyle } = ownerState;

    const { dark, white, text, transparent, gradients } = palette;
    const { size, fontWeightMedium, fontWeightRegular, fontWeightBold } = typography;
    const { navbarBoxShadow } = boxShadows;
    const { rgba, pxToRem } = functions;
    const { borderRadius } = borders;

    if (sidebarState == 'landing' || sidebarState == 'exploring') {
        if (deviceStyle == 'desktop') {
            return {
                backgroundColor: rgba(white.main, 0),
                color: white.main,
                borderRadius: borderRadius.xl,

                width: 'calc(100% - 48px)',
                height: 'calc(100svh - 48px)',
                marginTop: '24px',
                marginLeft: '24px',

                overflow: 'hidden',

                transition: "background-color 300ms ease, backdrop-filter 300ms ease, box-shadow 300ms ease, padding 300ms ease-in-out, border-radius 300ms ease-in-out"
            }
        }
        else {
            return {
                backgroundColor: rgba(white.main, 0),
                color: white.main,
                borderRadius: borderRadius.xl,

                width: '100%',
                height: 'calc(100svh - 48px)',
                marginTop: '8px',
                // marginLeft: '8px',

                overflow: 'hidden',

                transition: "background-color 300ms ease, backdrop-filter 300ms ease, box-shadow 300ms ease, padding 300ms ease-in-out, border-radius 300ms ease-in-out"
            }
        }
    }
    else if (sidebarState == 'sidenav') {
        if (deviceStyle == 'desktop') {
            return {
                boxShadow: navbarBoxShadow,
                backdropFilter: `saturate(200%) blur(${pxToRem(4)})`,
                backgroundColor: rgba(white.main, 0.8),
                color: white.main,
                borderRadius: borderRadius.xl,

                width: 'calc(100% - 48px)',
                height: 'calc(100svh - 48px)',
                marginTop: '24px',
                marginLeft: '24px',
                overflow: 'hidden',
                // transition: "background-color 300ms ease, backdrop-filter 300ms ease, box-shadow 300ms ease, padding 300ms ease-in-out, border-radius 300ms ease-in-out"
            }
        }
        else {
            return {
                boxShadow: navbarBoxShadow,
                backdropFilter: `saturate(200%) blur(${pxToRem(4)})`,
                backgroundColor: rgba(white.main, 0.8),
                color: white.main,
                borderRadius: borderRadius.xl,

                width: 'calc(100vw - 16px)',
                height: 'calc(100svh - 16px)',
                // marginTop: '24px',
                // marginLeft: '24px',
                overflow: 'hidden',
                // transition: "background-color 300ms ease, backdrop-filter 300ms ease, box-shadow 300ms ease, padding 300ms ease-in-out, border-radius 300ms ease-in-out"
            }
        }
    }
    else { //default
        return {
            boxShadow: navbarBoxShadow,
            backdropFilter: `saturate(200%) blur(${pxToRem(4)})`,
            backgroundColor: rgba(white.main, 0.8),
            color: white.main,
            borderRadius: borderRadius.xl,

            width: 'calc(100% - 48px)',
            height: 'calc(100svh - 48px)',
            marginTop: '24px',
            marginLeft: '24px',

            overflow: 'hidden',

            transition: "background-color 300ms ease, backdrop-filter 300ms ease"
        }
    }

}

export {
    DashboardCardStyle
}